module.exports = __webpack_public_path__ + "static/media/EditIconOnCard.ed510e71.svg";